import angular from 'angular';
import 'angular-sanitize';
import 'ui-select';
import '../../common/treeModule';
import './usersServices';

/**
 * @ngdoc overview
 * @name adminModule.usersControllers
 * @description
 * # adminModule.usersControllers
 * Module for managing the controllers of: users.
 */
var usersControllers = angular.module('adminModule.usersControllers', [
    'ngSanitize',
    'adminModule.usersServices',
    'commonModule.treeModule',
    'ui.select'
]);

(function () {
    'use strict';

    /**
     * @ngdoc controller
     * @name adminModule.usersControllers.controller:UsersListController
     * @description
     * Controller for Users List view
     */
    usersControllers.controller('UsersListController', ['$scope', 'NgTableParams', 'growl', 'User', 'AppsoupAPI', 'Permissions', '$modal', function ($scope, NgTableParams, growl, User, AppsoupAPI, Permissions, $modal) {

        $scope.writeAccess = Permissions.hasWriteAccess('user');
        $scope.search = {
            name: ''
        };
        $scope.isFind = false;
        $scope.check = false;

        $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
            getData: function (params) {
                $scope.isLoading = true;
                return User.getUsers(params && params._params ? params._params : {})
                    .then(function (response) {
                        params.total(response.total);
                        params.count(response.per_page);
                        params.page(response.current_page);
                        return response.data;
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                    });
            },
            counts: AppsoupAPI.getDefaultCounts()
        });

        $scope.export = function () {
            var modalInstance = $modal.open({
                templateUrl: 'views/admin/users/exportToJson.tpl.html',
                controller: 'UserExportToJsonModalController',
                backdrop: 'static',
                resolve: {
                    user: function () {
                        return {
                            app_id: $scope.application_id
                        };
                    }
                }
            });
            modalInstance.result.then(function (user) {
                $scope.tableParams.data.push(user);
                growl.success('MODULES.USERS.SUCCESS.EXPORT_USER');
            }).catch(() => {});
        };

        $scope.deleteUser = function (id, index) {
            User.remove(id)
                .then(function (response) {
                    const data = response.data;
                    if (data.success) {
                        growl.success('MODULES.USERS.SUCCESS.DELETE_USER');
                        $scope.tableParams.data.splice(index, 1);
                    } else if (data.error) {
                        growl.error('MODULES.USERS.' + data.error);
                    }
                });
        };

        $scope.searchUsers = function (search) {
            $scope.isFind = true;
            const find = angular.copy(search);
            angular.extend($scope.tableParams._params, find);
            $scope.isFind = false;
        };

        $scope.clearSearch = function () {
            $scope.search = {};
            if (angular.isDefined($scope.tableParams._params.name)) {
                $scope.tableParams._params.name = undefined;
            }
            if (angular.isDefined($scope.tableParams._params.email)) {
                $scope.tableParams._params.email = undefined;
            }
        };

        $scope.$watch('search', function () {
            $scope.check = false;
            angular.forEach($scope.search, function (val) {
                if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                    $scope.check = true;
                }
            });
        }, true);
    }]);

    /**
     * @ngdoc controller
     * @name adminModule.usersControllers.controller:UserPageController
     * @description
     * Controller for User Page view (new/edit user)
     */
    usersControllers.controller('UserPageController', ['$scope', '$rootScope', '$state', '$stateParams', '$filter', '$q', '$modal', 'growl', 'User', 'UserForm', 'Client', 'LanguageService', 'Permissions', function ($scope, $rootScope, $state, $stateParams, $filter, $q, $modal, growl, User, UserForm, Client, LanguageService, Permissions) {
        var userId = $stateParams.userId,
            duplicateUserId = $stateParams.duplicateUserId,
            promises = [],
            duplicateMode = (angular.isDefined(duplicateUserId) && duplicateUserId !== ""),
            editMode = angular.isDefinedNotNull(userId);

        $scope.writeAccess = Permissions.hasWriteAccess('user');
        $scope.showAdvanced = Permissions.hasSuperAdminAccess();
        $scope.showBuSelect = false;
        $scope.buTypes = [];
        const buTypesHistory = {};
        $scope.hasMainBu = false;

        var resetSelected = function () {
            $scope.selected = {places: [], levels: [], areas: [], zones: [], beacons: []};
        };

        $scope.editMode = false;
        $scope.user = {};
        $scope.formErrors = {};
        $scope.applications = [];
        $scope.shopIds = [];

        $rootScope.doingResolve = true;

        // Get form properties
        promises.push(UserForm.getForm());

        // Get user data
        if (editMode) {
            promises.push(User.getUser(userId));
        } else {
            if (!$scope.writeAccess) {
                $state.go('appsoup.admin.users');
            }
            resetSelected();
            if (duplicateMode) {
                promises.push(User.getUser(duplicateUserId));
            } else {
                var promise = $q.defer().resolve('No user data');
                promises.push(promise);
            }
        }

        $q.all(promises).then(function (response) {
            var formData = response[0].data,
                userResponse = response[1];

            // Form properties
            if (formData.success) {
                $scope.languages = formData.languages;
                $scope.user.lang = '1';
                $scope.user.client_id = $scope.ls.user.client_id;
                $scope.roles = formData.roles;
                $scope.places = formData.clientPermissions;
                if ($scope.ls.user.role_id) {
                    $scope.user.role_id = $scope.ls.user.role_id;
                }
            }

            // User data
            if (angular.isDefined(userResponse)) {
                if (userResponse.data.success) {
                    var user = userResponse.data.user,
                        applications = [];

                    if (angular.isDefinedNotNull(user.permissions)) {
                        applications = user.permissions.app || [];
                    }

                    if (duplicateMode) {
                        $scope.duplicateFrom = {name: user.name, email: user.email};
                        $scope.user.lang = String(user.lang);
                        $scope.user.client_id = user.client_id;
                        $scope.user.role_id = user.role_id;
                        $scope.applications = applications;
                        $scope.selected = UserForm.getUserPlacePermissions(user.permissions);
                    } else if (editMode) {
                        $scope.editMode = true;
                        $scope.user = UserForm.fillUserData(user, $scope.user.permissions);
                        $scope.applications = applications;
                        $scope.selected = UserForm.getUserPlacePermissions(user.permissions);
                        $scope.editMyself = ($scope.ls.user.email === $scope.user.email);
                    }
                    if ($scope.user.bu) {
                        buTypesHistory[$scope.user.client_id] = $scope.user.bu;
                    }
                } else if (userResponse.data.error) {
                    growl.error('MODULES.USERS.' + userResponse.data.error);
                    $state.go('appsoup.admin.users');
                }
            }
        }).finally($rootScope.doneLoading);

        var doneSaving = function () {
            growl.success('MODULES.USERS.SUCCESS.' + ($scope.editMode ? 'EDIT_USER' : 'NEW_USER'));
            $state.go('appsoup.admin.users');
        };

        $scope.saveUser = function () {
            $scope.$broadcast('show-errors-check-validity');

            if ($scope.userForm.$valid) {
                $scope.isLoading = true;
                $scope.user.app = $scope.applications;

                User.save($scope.user, $scope.selected, $scope.editMode)
                    .then(function (response) {
                        const data = response.data;
                        if (data.success) {
                            if ($scope.editMyself) {
                                LanguageService.changeTo($scope.user.lang)
                                    .then(function () {
                                        doneSaving();
                                    });
                            } else {
                                doneSaving();
                            }
                            $state.go('appsoup.admin.users');
                        } else if (angular.isDefinedNotNull(data.error.client_id)) {
                            growl.error('MODULES.USERS.' + data.error.client_id[0]);
                        } else {
                            $scope.formErrors = data.error;
                            $scope.$broadcast('show-errors-check-validity');
                        }
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                    });
            }
        };

        $scope.export = function () {
            var modalInstance = $modal.open({
                templateUrl: 'views/admin/users/exportToJson.tpl.html',
                controller: 'UserExportToHTMLModalController',
                backdrop: 'static'
            });
            modalInstance.result.then(function () {
                growl.success('MODULES.USERS.SUCCESS.EXPORT_USER');
            }).catch(() => {});
        };

        $scope.inputErrors = {
            'email': [{type: '$invalid', msg: 'ERROR.REQUIRE.EMAIL'}],
            'password': [{error: 'required', msg: 'ERROR.REQUIRE.PASS'}, {
                error: 'minlength',
                msg: 'ERROR.MIN_LENGTH.PASS',
                vars: '{ charsQty: 6 }'
            }],
            'repeatPass': [{error: 'required', msg: 'ERROR.REQUIRE.PASS'}, {
                error: 'minlength',
                msg: 'ERROR.MIN_LENGTH.PASS',
                vars: '{ charsQty: 6 }'
            }],
            'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}],
            'phone': [{error: 'pattern', msg: 'ERROR.PATTERN.PHONE'}],
            "userRole": [{type: '$invalid', msg: 'ERROR.REQUIRE.ROLE'}]
        };

        $scope.$watchGroup(['user.password_confirmation', 'user.password'], function () {
            var isValid = !($scope.user.password !== $scope.user.password_confirmation && !$scope.userForm.repeatPass.$pristine);
            $scope.userForm.repeatPass.$setValidity('match', isValid);
        });

        $scope.$watch('user.client_id', function (newValue, oldValue) {
            if (angular.isDefined(newValue) && Number.isFinite(newValue) && newValue !== oldValue) {
                $scope.user.bu = buTypesHistory[newValue] ? buTypesHistory[newValue] : null;

                if ($scope.showAdvanced) {
                    User.getClientPermissions(newValue)
                        .then(function (response) {
                            const data = response.data;
                            if (data.success) {
                                if (angular.isDefined(oldValue)) {
                                    resetSelected();
                                }
                                $scope.places = data.permissions;
                                $scope.noPlaces = false;
                            } else {
                                resetSelected();
                                $scope.noPlaces = true;
                            }
                        });
                }
                $scope.showBuSelect = false;
                User.getBuTypes(newValue)
                    .then(function (response) {
                        const data = response.data;
                        if (data.success) {
                            if (data.bu) {
                                $scope.buTypes = data.types;
                                $scope.buTypes.unshift(data.bu);
                                $scope.hasMainBu = true;
                            } else {
                                $scope.buTypes = data.types;
                                $scope.hasMainBu = false;
                            }
                            $scope.showBuSelect = !!($scope.buTypes && $scope.buTypes.length);
                        }
                    });
            }
        });

        $scope.onBuTypeChange = function () {
            buTypesHistory[$scope.user.client_id] = $scope.user.bu;
        };

        $scope.passMismatched = function () {
            if (angular.isDefined($scope.userForm)) {
                return $scope.userForm.repeatPass.$error.match;
            }
        };

        $scope.resetForm = function () {
            $state.go($state.current, {duplicateUserId: ''}, {reload: true});
        };

        $scope.cancel = function () {
            $state.go('appsoup.admin.users');
        };

    }]);

    usersControllers.controller('UserExportToJsonModalController', ['$scope', '$rootScope', '$state', '$stateParams', '$modalInstance', 'User', 'growl', function ($scope, $rootScope, $state, $stateParams, $modalInstance, User, growl) {
        $scope.application_id = $stateParams.application_id;
        $scope.userId = $stateParams.userId;

        $scope.ok = function () {
            $scope.$broadcast('show-errors-check-validity');
            if ($scope.passForm.$valid) {
                $scope.isLoading = true;

                User.downloadData($scope.password).then(function (response) {
                    const data = response.data;
                    if (data.success) {
                        $modalInstance.close(data.password);
                        angular.openInNewTab(data.url);
                    } else {
                        growl.error('MODULES.USERS.ERROR.EXPORT_USER');
                    }
                }).finally(function () {
                    $scope.isLoading = false;
                });
            } else {
                growl.error('MODULES.USERS.ERROR.EXPORT_VALIDATE');
            }
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.inputErrors = {
            'password': [{error: 'required', msg: 'ERROR.REQUIRE.PASS'}, {
                error: 'minlength',
                msg: 'ERROR.MIN_LENGTH.PASS',
                vars: '{ charsQty: 6 }'
            }]
        };
    }]);

    usersControllers.controller('UserExportToHTMLModalController', ['$scope', '$rootScope', '$state', '$stateParams', '$modalInstance', 'User', 'growl', function ($scope, $rootScope, $state, $stateParams, $modalInstance, User, growl) {

        $scope.ok = function () {
            $scope.$broadcast('show-errors-check-validity');
            if ($scope.passForm.$valid) {
                $scope.isLoading = true;

                User.downloadDataHTML($scope.password).then(function (response) {
                    const data = response.data;
                    if (data.success) {
                        $modalInstance.close(data.password);
                        angular.openInNewTab(data.url);
                    } else {
                        growl.error('MODULES.USERS.ERROR.EXPORT_USER');
                    }
                }).finally(function () {
                    $scope.isLoading = false;
                });
            } else {
                growl.error('MODULES.USERS.ERROR.EXPORT_VALIDATE');
            }
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.inputErrors = {
            'password': [{error: 'required', msg: 'ERROR.REQUIRE.PASS'}, {
                error: 'minlength',
                msg: 'ERROR.MIN_LENGTH.PASS',
                vars: '{ charsQty: 6 }'
            }]
        };
    }]);

})();

export default usersControllers;
